import type { FC, PropsWithChildren } from 'react';
import styles from './card.module.scss';

type CardWrapperProps = PropsWithChildren & React.HTMLAttributes<HTMLUListElement>;

export const CardWrapper: FC<CardWrapperProps> = ({ children, ...props }) => (
  <ul className={styles.wrapper} {...props}>
    {children}
  </ul>
);

type CardProps = PropsWithChildren & React.LiHTMLAttributes<HTMLLIElement> & { productName: string };

export const Card: FC<CardProps> = ({ children, productName, ...props }) => (
  <li {...props}>
    <label htmlFor={productName} className={styles['card-label']}>
      {children}
    </label>
  </li>
);
